export default __webpack_public_path__ + "static/media/hops.5b40abe0.jpg";